import { Draft, PayloadAction, PrepareAction } from "@reduxjs/toolkit";

export enum ProcessingType {
  ClearNotification = 1 << 0
}
export interface IActionMeta {
  processingType: ProcessingType;
}

export declare type CaseReducerWithPrepareAction<State, ReturnState, Action extends PayloadAction<T>, T = any> = {
  reducer: (state: Draft<State>, action: Action) => ReturnState;
  prepare: PrepareAction<T>;
};

const actionProcessingProvider = () => {
  const createMeta = (type: ProcessingType): { actionProcessing: IActionMeta } => ({
    actionProcessing: {
      processingType: type
    }
  });

  return {
    createWithClearNotification: <State, ReturnState extends State, T extends any>(
      reducer: (state: Draft<State>, action: PayloadAction<T>) => ReturnState
    ): CaseReducerWithPrepareAction<State, ReturnState, PayloadAction<T>> => {
      const prepare: PrepareAction<T> = (payload: T) => ({
        payload,
        meta: createMeta(ProcessingType.ClearNotification)
      });
      return {
        reducer: reducer,
        prepare: prepare
      };
    }
  };
};

export const actionProcessing = actionProcessingProvider();
